import { render } from "./PlanDetail.vue?vue&type=template&id=10e64c91&scoped=true"
import script from "./PlanDetail.vue?vue&type=script&lang=js"
export * from "./PlanDetail.vue?vue&type=script&lang=js"

import "./PlanDetail.vue?vue&type=style&index=0&id=10e64c91&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e64c91"]])

export default __exports__